<template>
  <FormBox>
    <span class="form-read-only">{{$attrs.value}}</span>
  </FormBox>
</template>

<script>
import FormBox from './FormBox'

export default {
  model: {
    prop: 'value',
    event: 'onChange'
  },
  components: {
    FormBox
  }
}
</script>

<style lang="scss" scoped>
.form-read-only {
  line-height: 40px;
  text-align: left;
}
</style>
